@if (cards.length && config?.display) {
    <div class="pb-0">
        @if (config?.collapsible) {
            <div class="w-full flex justify-content-end mb-3">
                <p-button
                    [icon]="collapsed ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
                    iconPos="right"
                    styleClass="transition-duration-200 border-1 surface-border surface-ground text-gray-300"
                    [text]="true"
                    [outlined]="true"
                    label="{{ 'default-cm-collapse' | translate: 'Collapse' }} "
                    (click)="toggleCollapse()"
                ></p-button>
            </div>
            @if (!collapsed) {
                <div class="flex surface-ground border-round-xl animation-duration-200 fadein p-3">
                    <div class="border-round-xl p-3 surface-50 flex flex-1 overflow-x-auto">
                        @for (card of cards; track i; let i = $index) {
                            <div
                                class="p-3 gap-3 surface-50 flex align-items-center justify-content-start w-20 min-w-min"
                            >
                                <div
                                    class="h-4rem w-4rem border-circle p-3 surface-ground flex align-items-center justify-content-center"
                                >
                                    <span
                                        class="material-symbols-outlined ng-star-inserted text-4xl"
                                        [style]="{ color: card.color }"
                                        >{{ card.icon }}</span
                                    >
                                </div>
                                <div class="flex flex-column gap-1">
                                    <p class="font-medium text-gray-300 text-xl m-0 white-space-nowrap">
                                        {{ card.label }}
                                    </p>
                                    <h1 class="m-0">{{ card.count | count }}</h1>
                                </div>
                            </div>
                            @if (!$last || cards.length < 5) {
                                <p-divider layout="vertical" class="surface-50"></p-divider>
                            }
                        }
                    </div>
                </div>
            }
        } @else {
            <div class="p-3 surface-ground border-round-xl">
                <div class="animation-duration-200 fadein border-round-xl p-3 surface-50 flex overflow-x-auto">
                    @for (card of cards; track i; let i = $index) {
                        <div
                            class="animation-duration-200 fadein p-3 gap-3 surface-50 flex align-items-center justify-content-start w-15rem min-w-min"
                        >
                            <div
                                class="h-4rem w-4rem border-circle p-3 surface-ground flex align-items-center justify-content-center"
                            >
                                <span
                                    class="material-symbols-outlined ng-star-inserted text-4xl"
                                    [style]="{ color: card.color }"
                                    >{{ card.icon }}</span
                                >
                            </div>
                            <div class="flex flex-column gap-1">
                                <p class="font-medium text-gray-300 text-xl m-0 white-space-nowrap">{{ card.label }}</p>
                                <h1 class="m-0">{{ card.count | count }}</h1>
                            </div>
                        </div>
                        <p-divider layout="vertical" class="surface-50"></p-divider>
                    }
                </div>
            </div>
        }
    </div>
}
